<template>
	<section class="promotions background-light main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row promotions-row align-left flex-row">
			<client-only>
				<div
					v-for="promoblock in promoblocks.slice(0, 4)"
					:key="promoblock.ID"
					class="columns column3 promo-wrap"
				>
					<nuxt-link :to="localePath(`/${promoblock.link}`)">
						<picture>
							<source v-if="promoblock.imageWebp" :srcset="promoblock.imageWebp" type="image/webp" />
							<source :srcset="promoblock.image" />
							<img loading="lazy" :src="promoblock.image" :alt="promoblock.imageAlt" />
						</picture>
					</nuxt-link>
					<div class="content">
						<h3>{{ promoblock.header }}</h3>
						<div v-parse-links v-html="promoblock.content" />
						<nuxt-link :to="localePath(`/${promoblock.link}`)" class="promo-button">
							{{ promoblock.button }}
							<font-awesome-icon icon="fa-light fa-arrow-right" size="1x" />
						</nuxt-link>
					</div>
				</div>
			</client-only>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	promoblocks: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.promotions-row {
	h3 {
		text-transform: uppercase;
	}

	.content {
		margin: 20px 0;
	}

	.promo-button {
		width: 100%;
		border-bottom: 1px solid #000;
		color: #000;
		text-transform: uppercase;
		font-family: var(--heading-font-family);
		font-size: 12px;
		line-height: 16px;
		padding: 8px 0;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;

		svg {
			font-size: 16px;
			transform: rotate(315deg);
			transition: all 0.2s ease-in-out;
		}

		&:hover {
			svg {
				transform: rotate(360deg);
			}
		}
	}
}

.promo-wrap {
	img {
		opacity: 0.9;
		transition: all 0.3s ease-in-out;
	}

	&:hover {
		img {
			opacity: 1;
		}
	}
}
</style>
